import { render, staticRenderFns } from "./demo_detail_bkp.vue?vue&type=template&id=53685b62"
import script from "./demo_detail_bkp.vue?vue&type=script&lang=js"
export * from "./demo_detail_bkp.vue?vue&type=script&lang=js"
import style0 from "./demo_detail_bkp.vue?vue&type=style&index=0&id=53685b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports